"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("@hotmart/cosmos/dist/dropdown/dropdown-toggle.css");
const Slot = ({ children, hasToggle = false }) => {
    const className = (0, classnames_1.default)({ 'hot-dropdown__toggle': hasToggle });
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children({ slot: 'button', className }) });
};
exports.default = Slot;
